'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.color = exports.textTransform = exports.textOverflow = exports.textDecoration = exports.whiteSpace = exports.auto = exports.none = exports.touchAction = exports.fontWeight = exports.verticalAlign = exports.textAlign = exports.overflow = exports.cursor = exports.display = exports.position = exports.margin = exports.padding = undefined;
exports.boxShadow = boxShadow;
exports.insetBoxShadow = insetBoxShadow;
exports.textShadow = textShadow;
exports.rgba = rgba;
exports.rgb = rgb;
exports.border = border;
exports.linearGradient = linearGradient;
exports.transform = transform;
exports.translate3d = translate3d;
exports.multi = multi;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function boxShadow(offsetX, offsetY, blurRadius, spreadRadius, color) {
  if (color === none || color == null) {
    return none;
  }
  return offsetX + 'px ' + offsetY + 'px ' + blurRadius + 'px ' + spreadRadius + 'px ' + color;
} /**
   * @copyright 2015+, Prometheus Research, LLC
   * 
   */

function insetBoxShadow(offsetX, offsetY, blurRadius, spreadRadius, color) {
  if (color === none || color == null) {
    return none;
  }
  return 'inset ' + boxShadow(offsetX, offsetY, blurRadius, spreadRadius, color);
}

function textShadow(offsetX, offsetY, blurRadius, color) {
  if (color === none || color == null) {
    return none;
  }
  return offsetX + 'px ' + offsetY + 'px ' + blurRadius + 'px ' + color;
}

function rgba(r, g, b, a) {
  if (b == null && a == null) {
    a = g;
    g = r;
    b = r;
  }
  if (b == null || a == null) {
    (0, _invariant2.default)(false, 'Invalid color format: rgba(%s, %s, %s, %s)', r, g, b, a);
  }
  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + a + ')';
}

function rgb(r, g, b) {
  if (g == null && b == null) {
    g = r;
    b = r;
  }
  if (g == null || b == null) {
    (0, _invariant2.default)(false, 'Invalid color format: rgb(%s, %s, %s)', r, g, b);
  }
  return 'rgb(' + r + ', ' + g + ', ' + b + ')';
}

function border(width, style, color) {
  if (color === undefined) {
    color = style;
    style = border.solid;
  }
  if (color === none || color === null) {
    return none;
  }
  return width + 'px ' + style + ' ' + color;
}

border.solid = 'solid';

function linearGradient(direction) {
  for (var _len = arguments.length, colorStops = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    colorStops[_key - 1] = arguments[_key];
  }

  var colorStopsStr = colorStops.map(function (p) {
    return typeof p === 'string' ? p : p.color + ' ' + p.value;
  }).join(', ');
  return 'linear-gradient(' + direction + ', ' + colorStopsStr + ')';
}

function transform(duration) {
  return 'transform ' + duration + 's';
}

function translate3d(x, y, z) {
  return 'translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)';
}

function sizeSeq() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return args.map(function (arg) {
    return typeof arg === 'string' ? arg : arg + 'px';
  }).join(' ');
}

function multi() {
  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return args.filter(function (item) {
    return item !== none;
  }).join(', ');
}

var padding = exports.padding = sizeSeq;
var margin = exports.margin = sizeSeq;

var position = exports.position = {
  absolute: 'absolute',
  relative: 'relative',
  fixed: 'fixed'
};

var display = exports.display = {
  block: 'block',
  inlineBlock: 'inline-block',
  flex: 'flex',
  inlineFlex: 'inline-flex',
  inline: 'inline'
};

var cursor = exports.cursor = {
  pointer: 'pointer',
  default: 'default'
};

var overflow = exports.overflow = {
  auto: 'auto',
  hidden: 'hidden',
  scroll: 'scroll'
};

var textAlign = exports.textAlign = {
  center: 'center',
  left: 'left',
  right: 'right'
};

var verticalAlign = exports.verticalAlign = {
  middle: 'middle',
  baseline: 'baseline',
  sub: 'sub',
  super: 'super',
  top: 'top',
  bottom: 'bottom'
};

var fontWeight = exports.fontWeight = {
  bold: 'bold',
  normal: 'normal'
};

var touchAction = exports.touchAction = {
  manipulation: 'manipulation'
};

var none = exports.none = 'none';

var auto = exports.auto = 'auto';

var whiteSpace = exports.whiteSpace = {
  nowrap: 'nowrap'
};

var textDecoration = exports.textDecoration = {
  none: 'none',
  underline: 'underline'
};

var textOverflow = exports.textOverflow = {
  ellipsis: 'ellipsis'
};

var textTransform = exports.textTransform = {
  none: 'none',
  capitalize: 'capitalize',
  uppercase: 'uppercase',
  lowercase: 'lowercase',
  fullWidth: 'full-width'
};

var color = exports.color = {
  transparent: 'transparent'
};
